const getCampNumberOfDays = (pack) => {
  // if weekend type => 2 days
  // if week type => number of weeks * 7 days
  if (!pack) return 0;

  const isWeekEnd = pack.durationId === 2;
  return isWeekEnd ? 2 : pack.numberOfWeeks * 7;
};

export default getCampNumberOfDays;
